import { useState } from "react";
import { useEffect } from "react";

import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import { useTheme } from "@mui/material/styles";

import OmniAssessmentImageListItem from "../ui/omniAssessmentImageListItem";

const QuestionMultiImageSelectDisplay = props => {
  const { question, onAnswerSelected, startNextTimer } = props;

  const defaultDelay = 350;
  const theme = useTheme();

  const [exclusiveAnswerSelected, setExclusiveAnswerSelected] = useState(false);

  const [localAnswer, setLocalAnswer] = useState([]);

  useEffect(() => {
    if (question.answerValue) {
      setLocalAnswer(question.answerValue);

      if (question.answerValue.length === 1) {
        for (let i = 0; i < question.answerOptions.length; i++) {
          if (question.answerOptions[i].value === question.answerValue[0]) {
            setExclusiveAnswerSelected(true);
          }
        }
      }
    }
  }, [question, setExclusiveAnswerSelected]);

  useEffect(() => {
    if (localAnswer.length === 0) {
      onAnswerSelected(null);
    } else {
      onAnswerSelected(localAnswer);
    }
  }, [localAnswer, onAnswerSelected]);

  const numColumns = 4;
  const mobileColumns = 2;
  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <ImageList cols={mobileLayout ? mobileColumns : numColumns} sx={{ maxHeight: 500 }}>
      {question.answerOptions.map((answerOption, index) => (
        <OmniAssessmentImageListItem
          color="primary"
          size="large"
          variant={"outlined"}
          key={`answerOptionImage${index}`}
          onClick={e => {
            e.stopPropagation();
            if (answerOption.isExclusive) {
              setLocalAnswer([answerOption.value]);
              onAnswerSelected([answerOption.value]);
              setExclusiveAnswerSelected(true);
              startNextTimer(defaultDelay);
            } else if (exclusiveAnswerSelected) {
              setLocalAnswer([answerOption.value]);
              onAnswerSelected([answerOption.value]);
              setExclusiveAnswerSelected(false);
            } else {
              let newAnswer = [];
              if (localAnswer.includes(answerOption.value)) {
                newAnswer = localAnswer.filter(ans => ans !== answerOption.value);
              } else {
                newAnswer = [...localAnswer, answerOption.value];
              }
              setLocalAnswer(newAnswer);
              setExclusiveAnswerSelected(false);
            }
          }}
        >
          <img
            //below works
            srcSet={`${answerOption.subText}?fit=crop&auto=format&dpr=2 2x`}
            src={`${answerOption.subText}?fit=crop&auto=format`}
            alt={answerOption.text}
            loading="lazy"
            sx={{ maxHeight: 200 }}
          />
          <ImageListItemBar
            sx={{ maxHeight: 42, color: theme.palette.secondary.contrastText }}
            title={answerOption.text}
            subtitle={
              answerOption.helpText ? <span>by: {answerOption.helpText}</span> : "Click to Select"
            }
            position="below"
            actionIcon={
              //   ((localAnswer && localAnswer.includes(answerOption.value)) ||
              //   (!localAnswer &&
              //     question.answerValue &&
              //     question.answerValue.includes(answerOption.value))) && {
              //   display: "unset",
              //   opacity: 1,
              // },
              (localAnswer && localAnswer.includes(answerOption.value)) ||
              (!localAnswer &&
                question.answerValue &&
                question.answerValue.includes(answerOption.value)) ? (
                <CheckBox
                  sx={{
                    marginTop: theme.spacing(1.5),
                    color: theme.palette.secondary.contrastText,
                  }}
                />
              ) : (
                <CheckBoxOutlineBlank
                  sx={{
                    marginTop: theme.spacing(1.5),
                    color: theme.palette.secondary.contrastText,
                  }}
                />
              )
            }
          />
        </OmniAssessmentImageListItem>
      ))}
    </ImageList>
  );
};

export default QuestionMultiImageSelectDisplay;
